var exports = {
  "kL": "x31de4314--518a58--container",
  "iE": "x31de4314--518a58--wrapper",
  "VH": "x31de4314--518a58--preview",
  "qV": "x31de4314--518a58--skeleton",
  "Qs": "x31de4314--518a58--content",
  "n8": "x31de4314--518a58--line",
  "Zp": "x31de4314--518a58--layout",
};

module.exports = exports;
